export default "__VITE_ASSET__DkmU1zr0__"